<script lang="ts">
	import { page } from '$app/stores';
	import { fade, scale, slide } from 'svelte/transition';
	import { linear } from 'svelte/easing';
	import ReminderModal from './ReminderModal.svelte';
	import { onMount } from 'svelte';
</script>

<div
	class="absolute left-0 top-0 z-40 w-full {!$page.data.embed
		? 'h-[calc(100dvh-60px)] lg:h-[calc(100dvh-162px)]'
		: 'h-screen lg:h-[calc(100dvh-82px)]'}"
>
	<div class="relative h-full w-full">
		<section
			class="flex h-full w-full flex-col items-center justify-center bg-black bg-opacity-20 backdrop-blur-sm lg:hidden"
			transition:fade
		>
			<div transition:scale>
				<ReminderModal on:close />
			</div>
		</section>
		<section
			class="animate-popup-shake absolute bottom-0 right-0 hidden lg:block"
			transition:slide={{ easing: linear }}
		>
			<ReminderModal class="drop-shadow-lg" on:close />
		</section>
	</div>
</div>

<style>
	@keyframes popup-shake {
		0% {
			transform: translateX(0);
		}
		2% {
			transform: translateX(-10px);
		}
		4% {
			transform: translateX(10px);
		}
		6% {
			transform: translateX(-10px);
		}
		8% {
			transform: translateX(0);
		}
	}

	.animate-popup-shake {
		animation: popup-shake 5s ease infinite;
	}
</style>
